import api from './authApi';

/**
 * Get teacher's assigned batches
 */
export const getTeacherBatches = async (params = {}) => {
  try {
    const response = await api.get('/admin/batches', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching teacher batches:', error);
    throw error;
  }
};

/**
 * Get batch details with modules and students
 */
export const getBatchDetails = async (batchId) => {
  try {
    const response = await api.get(`/admin/batches/${batchId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching batch details:', error);
    throw error;
  }
};

/**
 * Update batch information
 */
export const updateBatch = async (batchId, data) => {
  try {
    const response = await api.put(`/admin/batches/${batchId}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating batch:', error);
    throw error;
  }
};

/**
 * Get students in a batch
 */
export const getBatchStudents = async (batchId) => {
  try {
    const response = await api.get(`/admin/batches/${batchId}/students`);
    return response.data;
  } catch (error) {
    console.error('Error fetching batch students:', error);
    throw error;
  }
};

/**
 * Add students to a batch
 */
export const addStudentsToBatch = async (batchId, studentIds) => {
  try {
    const response = await api.patch(`/admin/batches/${batchId}/students`, { studentIds });
    return response.data;
  } catch (error) {
    console.error('Error adding students to batch:', error);
    throw error;
  }
};

/**
 * Remove student from batch
 */
export const removeStudentFromBatch = async (batchId, studentId) => {
  try {
    const response = await api.delete(`/admin/batches/${batchId}/students/${studentId}`);
    return response.data;
  } catch (error) {
    console.error('Error removing student from batch:', error);
    throw error;
  }
};

/**
 * Get batch modules
 */
export const getBatchModules = async (batchId) => {
  try {
    const response = await api.get(`/admin/batches/${batchId}/modules`);
    return response.data;
  } catch (error) {
    console.error('Error fetching batch modules:', error);
    throw error;
  }
};

export const batchApi = {
  getTeacherBatches,
  getBatchDetails,
  updateBatch,
  getBatchStudents,
  addStudentsToBatch,
  removeStudentFromBatch,
  getBatchModules,
};

export default batchApi;